












































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { setMetaData, timeFormat,downloadFile, setValue } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import {
  GetOptionsForAttendanceReportReq,
  ListGroupAttendanceReq
} from "@/pbjs/external/user/user_pb";
import {
  ticketClient,
  authorClient,
  collectionServiceClient,
  client
} from "@/api/index";
import {
  GetTicketListParamReq,
  WorkOrderStatisticReq,
} from "@/pbjs/xcommon/ticket_pb";

@Component({
  name: "PerformanceManagement",
  filters: {
    filter(value: any,key:any) {
      const filterArr =  value.filter((item:any)=>{
          return  item[0]==key
      })
      return filterArr.length > 0 ? filterArr[0][1].total:0
    },
    filterpercent(value: any,key:any) {
      const filterArr1 =  value.filter((item:any)=>{
          return  item[0]==key
      })
      // var num=  (Math.round(filterArr1[0][1].percentage*100)/100)+'%'
      return filterArr1.length > 0 ? (Math.round(filterArr1[0][1].percentage*100)/100)+'%' :"0%"
    },
    percenttage(num:any){
      return (Math.round(num*100)/100)+'%'
    }
  }
})

export default class PerformanceManagement extends Vue {
  @Provide() private searchForm: any = {
    Timerange: null,
    itemId: null
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private ticketTypeOptions: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private updatedTime: any = "";
  @Provide() private resultData: any = [];
  @Provide() private roleOptions: any = [];
  @Provide() private totalData: any = [];
  @Provide() private isGetTicketListExcelActionDone: any = false;
  @Provide() private connectedmap: any = [];
  @Provide() private unconnectedmap: any = [];
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示

  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  } //  角色
  private created() {
    // this.getOptionsForAttendanceReport();
    this.getTicketListParam()
    // this.getAttendanceReport();
  }

 //百分比转换
 private percenttage(num:number){
  return (Math.round(num*100)/100)+'%'
 }


private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(JSON.stringify(data), "param");
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private getTicketListParamFuc(data: any) {
    console.log("getTicketListParamFuc", data);
    this.ticketTypeOptions = data.ticketitemList;
  }
  private getTicketListExcelAction() {
    this.isGetTicketListExcelActionDone = true;
    // this.pageIndex = 1;
    this.getTicketListExcel();
  }
   //  导出功能
  private async getTicketListExcel() {
    if (this.limitTimeRange()) {
      // if (this.dwGetTicketListReqParamsNeed()) {
        let request:any=new WorkOrderStatisticReq()
        request.setCommonin(setCommon());
        request.setPagein(setPage(this.pageIndex, this.pageSize));
        request.setItemid(this.searchForm.itemId)
        request.setTimerange(timeFormat(this.searchForm.Timerange[0]) +
        " - " +
        timeFormat(this.searchForm.Timerange[1]))
        console.log(request);
        ticketClient.workOrderStatisticExcel(request,{}, (err: any, response: any) => {
            if (response) {
                this.isGetTicketListExcelActionDone = response.loading
            ? response.loading
            : false;
          // console.log(response, response.array[3], "exportFormAction");
          if (response.array[3] && response.array[3].length > 0) {
            const blob = new Blob([response.array[3]], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            downloadFile(blob, response.array[2]);
          } else {
            this.isGetTicketListExcelActionDone = false;
            this.$message.error(response.array[0][1]);
          }
         }else {
          this.isGetTicketListExcelActionDone = false;
        }
        })
      }
    // }
  }
  private limitTimeRange() {
    // console.log(this.ruleForm, "limitTimeRange",);
    // console.log(this.ruleForm.createTimeRange[0], this.ruleForm.createTimeRange[1], new Date(this.ruleForm.createTimeRange[0]).getMonth(),  "limitTimeRange",);
    if (
      (this.searchForm.Timerange && this.searchForm.Timerange[0])
    ) {
      if (
        this.limitInOneMonth(
          this.searchForm.Timerange,
          this.searchForm.Timerange
            ? this.searchForm.Timerange[0]
            : false,
          this.searchForm.Timerange
            ? this.searchForm.Timerange[1]
            : false
        )
      ) {
        return true;
      } else {
          this.isGetTicketListExcelActionDone = false;
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );

        return false;
      }
    }
    this.isGetTicketListExcelActionDone = false;
    this.$message.warning(
      "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
    );
    return false;
  }
   // 导出时需限制所选时间段不可超过一个月，如不符合则提示：
  //   请选择连续时间不超过一个月的数据。=Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes.
  private limitInOneMonth(obj: any, begin: any, end: any) {
    if (obj && begin) {
      // console.log(
      //   new Date(begin).getTime(),
      //   new Date(end).getTime(),
      //   new Date(begin).getMonth() === new Date(end).getMonth(),
      //   new Date(begin).getMonth() + 1 === new Date(end).getMonth()
      // );
      if (
        new Date(begin).getTime() < new Date(end).getTime() &&
        new Date(end).getTime() <=
          new Date(begin).getTime() + 31 * 24 * 60 * 60 * 1000
      ) {
        return true;
      } else {
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );
        this.isGetTicketListExcelActionDone = false;
        return false;
      }
    } else {
      return true;
    }
  }
  //  必传参数处理
  private dwGetTicketListReqParamsNeed() {
    if (
      this.searchForm.itemId
    ) {
      return true;
    } else {
      this.isGetTicketListExcelActionDone = false;
      this.$message.error(
        this.$tc(
          "pls make sure you’ve provided one of Ticket ID/Ticket category at least"
        )
      );
      return false;
    }
  }
  //查询
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getAttendanceReport();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getAttendanceReport();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getAttendanceReport();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getAttendanceReport();
  }

  private isNull(val: any): boolean {
    if (val) {
      return false;
    }
    return true;
  }
 private getAttendanceReportFunc(data:any){
     console.log(data);
     this.pagerCount=data.pageout.total
     this.resultData=data.listList
     this.connectedmap=data.urgeresultconnectedmapMap
     this.unconnectedmap=data.urgeresultunconnectedmapMap
 }
  // lee 获取列表
//   private async getAttendanceReport() {}
  private getAttendanceReport() {
    console.log(this.searchForm);
    // let this.: any = (data: any) => {
    //   this.resultData = data.attendancereportformList;
    //   this.totalData = data.attendancereportsummary;
    // };
     if (this.limitTimeRange()) {
      // if (this.dwGetTicketListReqParamsNeed()) {
    this.isSearchFormActionDone=true
    let request:any=new WorkOrderStatisticReq()
        request.setCommonin(setCommon());
        request.setPagein(setPage(this.pageIndex, this.pageSize));
        request.setItemid(Number(this.searchForm.itemId) )
        request.setTimerange(timeFormat(this.searchForm.Timerange[0]) +
        " - " +
        timeFormat(this.searchForm.Timerange[1]))
        console.log(request);
        ticketClient.workOrderStatistic(request,{}, (err: any, response: any) => {
            if (response) {
          let data: any = response.toObject();
          this.isSearchFormActionDone=false
          console.log(data, "GetAttendanceReport");
           let _fuc=this.getAttendanceReportFunc(data)
          handleResponse(data,_fuc);
        }
        if (err) {
          this.isSearchFormActionDone=false
          errorMsg(err);
        }
      }
    );
  }
  // }
  }
}
